import React,{ useState, useRef, useEffect, useContext } from 'react';
import './Header.css'
import logo from '../../assets/Logo-BGSM.png'
import { AppContext } from '@edx/frontend-platform/react';
import {  ensureConfig, getConfig } from '@edx/frontend-platform';

ensureConfig([
  'LMS_BASE_URL',
  'LOGOUT_URL',
  'BASE_URL',
  'STUDIO_BASE_URL',
], 'Header component');

function Header() {
  const { authenticatedUser } = useContext(AppContext);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

    return (
        <div className="header-1">
            <div className="header-logo">
               <a href={`${getConfig().STUDIO_BASE_URL}/home`}><img src={logo} alt="User Profile" /></a>
            </div>

            <div className="right-side-button">
                <div className="dropdown-container" ref={dropdownRef}>
                <button
                    onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                    className="admin-button"
                >
                <span>{authenticatedUser?.username}</span>
                <svg
                   className={`dropdown-arrow ${isDropdownOpen ? 'rotate' : ''}`}
                   fill="none"
                   stroke="currentColor"
                   viewBox="0 0 24 24"
                >
                  <path
                     strokeLinecap="round"
                     strokeLinejoin="round"
                     strokeWidth={2}
                     d="M19 9l-7 7-7-7"
                  />
                </svg>
               </button>

               {isDropdownOpen && (
                  <div className="dropdown-menu-1">
                     <div className="dropdown-content">
                       <a href={`${getConfig().STUDIO_BASE_URL}/home`} className="dropdown-item-1">
                          Studio Home
                       </a>
                       <a href={`${getConfig().STUDIO_BASE_URL}/maintenance`} className="dropdown-item-1">
                          Maintenance
                       </a>
                       <a href="/admin-report/" className="dropdown-item-1">
                          Reports
                       </a>
                       <a href={`${getConfig().COURSE_AUTHORING_MICROFRONTEND_URL}/notification-panel`} className="dropdown-item-1">
                          Notification Panel
                       </a>
                       <a href={getConfig().LOGOUT_URL} className="dropdown-item-1">
                          Logout
                       </a>
                     </div>
                   </div>
                )}
          </div>
         </div>
       </div>
    );
};

export default Header;
